var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_vm._v(" "),_c('MessageNotification')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/App.vue?vue&type=template&id=0a9df14e&
// module id = null
// module chunks = 